module.exports = __webpack_public_path__ + "img/align-middle.61ffe370.svg";